import * as React from "react";

function IconOutlinedCheckInCircle(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_725_26308)" fill="#DBDCDF">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.334 8.5l-4.667 4.667a.756.756 0 01-.583.25.756.756 0 01-.584-.25l-2.833-2.833a.806.806 0 010-1.167.806.806 0 011.167 0l2.25 2.25 4.083-4.083a.806.806 0 011.167 0 .806.806 0 010 1.166z"
        />
        <path d="M10 2.5c4.166 0 7.5 3.333 7.5 7.5s-3.334 7.5-7.5 7.5A7.469 7.469 0 012.5 10c0-4.167 3.333-7.5 7.5-7.5zm0-1.667A9.14 9.14 0 00.833 10 9.14 9.14 0 0010 19.167 9.14 9.14 0 0019.166 10 9.14 9.14 0 0010 .833z" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_725_26308">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconOutlinedCheckInCircle = React.memo(IconOutlinedCheckInCircle);
export default MemoIconOutlinedCheckInCircle;
